<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter v-if="!showOnReport" :orderbutton="true" :listStatus="listStatus" :headers="filter_headers" :viewName="viewName" :orderSummary="orderSummary" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-widget title="Thống kê chi phí" v-if="!showOnReport && selectedOrders.length > 0">
              <div slot="widget-header-action">
                <v-layout row wrap class="pr-1">
                  <v-btn @click="mergeOrder" v-if="(paymentRole || adminRole) && selectedOrders.length > 1">
                    <v-icon color="red darken-3">fa-list-alt</v-icon> Gộp đơn
                  </v-btn>
                  <div class="ml-2">
                    <order-flag-menu :orderIDs="selectedOrders.map(item => item.ID)" :orderType="1"></order-flag-menu>
                  </div>
                </v-layout>
              </div>
              <div slot="widget-content">
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Số đơn hàng:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.length}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Tổng tiền:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Đã cọc:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Cần cọc:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.MinDeposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Còn thiếu:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{(selectedOrders.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) - selectedOrders.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0)) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
              </div>
          </v-widget>
          <v-data-table
            :headers="headers"
            :items="orders"
            :must-sort="true"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :loading="loading"
            show-select
            :mobile-breakpoint="100"
            v-model="selectedOrders"
            item-key="ID"
            class="elevation-1"
          >
            <template v-slot:item="{ item, isSelected, select}">
              <tr :active="isSelected">
                <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                <td>
                  <a target="blank" :href="`/don-hang/${item.ID}`">{{ 'MD'+item.ID }}</a>
                </td>
                <td>
                  <a target="blank" :href="`${official_url}/quotations/${item.QuotationID}`" v-if="item.QuotationID">{{ 'QT-'+item.QuotationID }}</a>
                </td>
                <td>{{ item.Site }}</td>
                <td>{{ item.SourceDomain }}</td>
                <td>
                  <v-chip :color="get_order_status_color(item.Status)" label outlined small> {{ item.Status | order_status}}</v-chip>
                  <span class="order-status-additional red--text" v-if="item.RealStoreName">{{item.RealStoreName}}</span>
                  <span class="order-status-additional" v-else>{{getStoreName(item.Status, item.ChinaStoreID, item.ReceivePlaceID)}}</span>
                  <span class="order-status-additional" v-if="item.UnPayable">Đơn hàng tồn tại kiện chưa có số liệu</span>
                </td>
                <td>
                  <v-img :src="proxyImage(item.image_origin && item.image_origin.includes('firebase') ? item.image_origin : decodeURIComponent(item.image_origin))" width="64px" height="64px"></v-img>
                </td>
                <td class="text-end font-weight-bold">{{ item.TotalAmountVND | currency}}</td>
                <td class="text-end font-weight-bold">{{ item.MinDeposit | currency}}</td>
                <td v-if="orderRole & 1">
                  <a target="_blank" :href="'khach-hang/quan-ly-khach-hang/' + item.UID">{{ item.CustomerName }}</a>
                </td>
                <td v-else>
                  {{ item.CustomerName }}
                </td>
                <td>{{ item.ProvinceID | display_value(provinces, 'id', 'name') }}</td>
                <td v-if="orderRole & 512 && !storeRole">
                  <v-edit-dialog
                    :return-value.sync="item.BuyerName"
                    large
                    lazy
                    persistent
                    @save="saveStaff({ OrderID: item.ID, BuyerID: item.BuyerID | 0})"
                  >
                    <div>{{ item.BuyerName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="p_staffs"
                        v-model="item.BuyerID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.BuyerName = getStaffName(item.BuyerID)"
                        clearable
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-else>
                  {{ item.BuyerName }}
                </td>
                <td v-if="!storeRole">
                  <v-edit-dialog
                    :return-value.sync="item.SaleName"
                    large
                    lazy
                    persistent
                    @save="saveStaff({ OrderID: item.ID, SalerID: item.SalerID | 0})"
                  >
                    <div>{{ item.SaleName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="sale_staffs"
                        v-model="item.SalerID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.SaleName = getStaffName(item.SalerID)"
                        clearable
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-else>
                  {{ item.SaleName }}
                </td>
                <td v-if="!storeRole">
                  <v-edit-dialog
                    :return-value.sync="item.CSName"
                    large
                    lazy
                    persistent
                    @save="saveStaff({ OrderID: item.ID, CustomerServiceID: item.CustomerServiceID | 0})"
                  >
                    <div>{{ item.CSName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="cs_staffs"
                        v-model="item.CustomerServiceID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.CSName = getStaffName(item.CustomerServiceID)"
                        clearable
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-else>
                  {{ item.CSName }}
                </td>
                <td>
                  {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                  <br v-if="item.IsFoam" />
                  {{ item.IsFoam ? 'Bọt khí' : '' }}
                  <br v-if="item.IsCheck" />
                  {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                  <br v-if="item.GuaranteeType" />
                  {{ item.GuaranteeType ? 'Bảo hiểm' : '' }}
                </td>
                <td>
                  {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.CreatedDate | display_date('HH:mm:ss')}}
                </td>
                <td>
                  {{ item.BoughtDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.BoughtDate | display_date('HH:mm:ss')}}
                </td>
                <!-- <td>
                  {{ item.SignalDatePackage | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.SignalDatePackage | display_date('HH:mm:ss')}}
                </td> -->
                <td>
                  {{ item.ShopDeliverDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.ShopDeliverDate | display_date('HH:mm:ss')}}
                </td>
                <td>
                  {{ item.StoreCNExDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.StoreCNExDate | display_date('HH:mm:ss')}}
                </td>
                <td>
                  {{ item.StoreVNExDate | display_date('DD-MM-YYYY')}}
                  <br />
                  {{ item.StoreVNExDate | display_date('HH:mm:ss')}}
                </td>
                <td class="text-center">
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon medium @click="gotoDetail(item.ID)" v-on="on">fa-external-link-alt</v-icon>
                      </template>
                      <span>Chi tiết đơn hàng</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogNew" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg4 md4 sm12 xs12>
                <v-autocomplete label="Khách hàng" v-model="newOrder.UID" :items="customers" item-text="Username" item-value="ID"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12>
                <v-autocomplete label="Cấp độ an toàn" clearable v-model="newOrder.SafeLevelID" :items="safeLevels" item-text="Name" item-value="ID" item-disabled="HideOnAdmin"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12>
                <p class="body-2 font-weight-bold text-red">Danh sách sản phẩm</p>
                <v-list>
                  <v-list-item v-for="(item, index) in newOrder.Products" :key="item.ID">
                    <v-list-item-content>
                      <v-flex lg2 md2 sm12 xs12>
                    <v-text-field label="Link sản phẩm" v-model="item.Link"></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12 xs12>
                      <!-- <v-text-field label="Link ảnh" v-model="item.Image"></v-text-field> -->
                      <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="`${getImages(index)}`" ref="imageFile"/>
                    </v-flex>
                    <v-flex lg4 md4 sm12 xs12>
                      <v-text-field label="Thuộc tính" v-model="item.Property"></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12 xs12>
                      <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="item.Price"></h-currency-input>
                    </v-flex>
                    <v-flex lg2 md2 sm12 xs12>
                      <h-currency-input label="Số lượng" :decimal="0" v-model="item.Quantity"></h-currency-input>
                    </v-flex>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="newOrder.Products.splice(index, 1);">
                        <v-icon>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-layout row wrap>
                  <v-flex lg2 md2 sm12 xs12>
                    <v-text-field label="Link sản phẩm" v-model="newProduct.Link"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12 xs12>
                    <v-text-field label="Link ảnh" v-model="newProduct.Image"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12 xs12>
                    <div class="col-md-12 box-right fb flex-c text-red form-group" style="padding: 0;">
                        <div class="row">
                            <div class="col-md-4">
                                <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="newProduct.Image" ref="imageFile"/>
                            </div>
                            <div class="col-md-8">
                                <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
                                <button @click="chooseImage(newProduct)" style="cursor: point">Tải ảnh</button>
                            </div>
                        </div>
                    </div>
                  </v-flex>
                  <v-flex lg3 md3 sm12 xs12>
                    <v-text-field label="Thuộc tính" v-model="newProduct.Property"></v-text-field>
                  </v-flex>
                  <v-flex lg1 md1 sm12 xs12>
                    <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="newProduct.Price"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12 xs12>
                    <h-currency-input label="Số lượng" :decimal="0" v-model="newProduct.Quantity"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12 xs12>
                    <v-btn icon large @click="appendProduct"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VWidget from "@/components/VWidget";
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import OrderFlag from "@/components/widgets/OrderFlag";
import { sendErrorNotice, sendSuccessNotice, makeid, proxyImage } from "@/commons/utils";
import firebase from 'firebase';
import moment from "moment";
export default {
  components: {
    VWidget,
    "hpo-filter": Filtering,
    'order-flag-menu': OrderFlag,
  },
  props: ["showOnReport", "filterReport"],
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      official_url: process.env.VUE_APP_OFFICIAL_URL,
      proxyImage: proxyImage,
      imageData: null,
      hideImage: false,
      search: "",
      selectedOrders: [],
      headers: [       
        {
          text: "Order ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          dataType: dataType["Number"]
        },
        {
          text: "Báo giá",
          value: "QuotationID",
          filterable: true,
          width: "80px",
          dataType: dataType["Number"]
        },
        {
          text: "Site",
          value: "Site",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Domain",
          value: "SourceDomain",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.ORDER_STATUS
        },
        {
          text: "Ảnh SP",
          value: "image_origin",
          sortable: false,
          filterable: false,
          dataType: dataType["String"]
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tiền cần cọc",
          value: "MinDeposit",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Khách hàng",
          value: "CustomerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Tỉnh/TP",
          value: "ProvinceID",
          filterable: true,
          values: [],
          dataType: dataType["Enum"]
        },
        {
          text: "Mua hàng",
          value: "BuyerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Sale nhập hàng",
          value: "SaleName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Nhân viên CS",
          value: "CSName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Lưu ý đặc biệt",
          sortable: false,
          filterable: false,
        },
        {
          text: "Ngày lên đơn",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày mua hàng",
          value: "BoughtDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        // {
        //   text: "Ký nhận",
        //   value: "SignalDatePackage",
        //   filterable: true,
        //   sortable: true,
        //   dataType: dataType["Date"]
        // },
        {
          text: "Phát hàng",
          value: "ShopDeliverDate",
          filterable: true,
          sortable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Xuất kho gửi",
          value: "StoreCNExDate",
          filterable: true,
          sortable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Xuất kho nhận",
          value: "StoreVNExDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Thao tác",
          align: "center",
        }
      ],
      pagination: {
          ...configs.PAGINATION,
          sortBy: ["ID"]
      },
      selectedTab: 0,
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      listStatus: configs.ORDER_STATUS,
      viewName: "order_list",
      filterConditions: [],
      quickFilterConditions: [],
      totalDeposit: 0,
      dialogNew: false,
      newProduct: {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      },
      newOrder: {
        UID: 0,
        Products: []
      },
      export_options: {
        start_date: moment.utc(Date.now()).subtract(1, 'days').format(configs.SHORT_DATE_FORMAT),
        end_date: moment.utc(Date.now()).format(configs.SHORT_DATE_FORMAT)
      },
      date_validation: [v => v.match(/^(0?[1-9]|[12][0-9]|3[01])[\-](0?[1-9]|1[012])[\-]\d{4}$/) || "DD-MM-YYYY"]
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    orders: function(val) {
      this.selectedOrders = [];
    },
    filterReport: function(val) {
      if(this.showOnReport) {
        this.filter_data();
      }
    },
    provinces() {
      let header_item = _.find(this.headers, {value: "ProvinceID"});
      if(header_item) {
        header_item.values = _.map(this.provinces, (item) => {
          return {
              value: item.id,
              name: item.name
          }
        }) || []
      }
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration.selected,
      orders: state => state.main_order.all.data,
      orderSummary: state => state.main_order.all.summary,
      total_rows: state => state.main_order.all.total,
      loading: state => state.main_order.loading,
      staffs: state => state.commons.all_users,
      p_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return o.is_active && (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        }),
      sale_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return o.is_active && (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService && (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        }),
      cs_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return o.is_active && (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        }),
      customers: state => state.customer.master.data,
      guarantees: state => {
          let tmp = [{name: 'Không sử dụng', value: 0}];
          if(state.feeGuarantee.all.data) {
          state.feeGuarantee.all.data.forEach(element => {
              tmp.push({name: element.PackageName, value: element.ID});
          });
          }
          return tmp;
      },
      warehouses: state => state.commons.stores,
      chinaStores: state => state.commons.chinaStores,
      provinces: state => state.commons.provinces,
      safeLevels: state => state.safeLevel.all.data,
      allFlags: state => _.map(state.flag.all.data, (item) => {
          return {
              value: item.ID,
              name: item.FlagName,
              color: item.FlagColor
          }
      })
    }),
    product_types() {
      return this.configuration && this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
    },
    pages() {
      return Math.ceil(
        this.total_rows / this.options.itemsPerPage
      );
    },
    filter_headers() {
      let tmp = [...this.headers];
      tmp.push({
          text: "Đóng gỗ",
          value: "IsFragileGoods",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Kiểm hàng",
          value: "IsCheck",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Bảo hiểm",
          value: "GuaranteeType",
          filterable: true,
          values: this.guarantees,
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
        text: "Ngày đặt cọc",
        value: "DepositDate",
        filterable: true,
        dataType: configs.DATA_TYPE["Date"]
      });
      tmp.push({
        text: "Ngày thanh toán",
        value: "PaymentDate",
        filterable: true,
        dataType: configs.DATA_TYPE["Date"]
      });
      tmp.push({
        text: "Nhập kho gửi",
        value: "StoreCNImDate",
        filterable: true,
        dataType: configs.DATA_TYPE["Date"]
      });
      tmp.push({
        text: "Nhập kho nhận",
        value: "StoreVNImDate",
        filterable: true,
        dataType: configs.DATA_TYPE["Date"]
      });
      tmp.push({
        text: "Đơn giá VCQT (NY)",
        value: "ListedFeeWeight",
        filterable: true,
        dataType: configs.DATA_TYPE["Number"]
      });
      tmp.push({
        text: "Đơn giá VCQT",
        value: "FeeWeight",
        filterable: true,
        dataType: configs.DATA_TYPE["Number"]
      });
      tmp.push({
        text: "Đã thanh toán",
        value: "PaymentStatus",
        filterable: true,
        values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
        dataType: configs.DATA_TYPE["Enum"]
      });
      tmp.push({
        text: "Lý do huỷ đơn",
        value: "CancelReason",
        filterable: true,
        values: configs.CANCEL_REASON,
        dataType: configs.DATA_TYPE["Enum"]
      });
      tmp.push({
        text: "Đơn đầu tiên",
        value: "IsFirstOrder",
        filterable: true,
        values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
        dataType: configs.DATA_TYPE["Enum"]
      });
      tmp.push({
        text: "Đã kiểm tra tài chính",
        value: "CheckPayment",
        filterable: true,
        values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
        dataType: configs.DATA_TYPE["Enum"]
      });
      tmp.push({
        text: "Loại hàng",
        value: "ProductType",
        filterable: true,
        values: this.product_types,
        dataType: configs.DATA_TYPE["Enum"]
      });
      tmp.push({
          text: "Kho gửi",
          value: "ChinaStoreID",
          filterable: true,
          values: _.map(this.chinaStores, (item) => {
              return {
              value: item.ID,
              name: item.Name,
              };
          }) || [],
          dataType: configs.DATA_TYPE["Enum"]
      });
      tmp.push({
          text: "Kho nhận",
          value: "ReceivePlaceID",
          filterable: true,
          values: _.map(this.warehouses, (item) => {
              return {
              value: item.ID,
              name: item.Name,
              };
          }) || [],
          dataType: configs.DATA_TYPE["Enum"]
      });
      tmp.push({
        text: "Hashtag",
        value: "FlagID",
        filterable: true,
        dataType: configs.DATA_TYPE["Enum"],
        values: this.allFlags
      });
      tmp.push({
        text: "Thiếu kiện",
        value: "IsPackNotMatch",
        filterable: true,
        dataType: configs.DATA_TYPE["Enum"],
        values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
      });
      return tmp;
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    storeRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
    },
    orderRole() {
      return this.$store.state.authentication.role.Orders;
    },
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      if(this.showOnReport) {
        param.filter = this.filterReport;
      }      
      this.$store.dispatch("main_order/getListOrders", param);
      this.$store.dispatch("feeGuarantee/getList");
      this.getCustomerList();
    },
    gotoDetail: function(id) {
      let routeData = this.$router.resolve({
        name: "OrderDetail",
        params: {
          Pid: id,
          title: `Chi tiết đơn hàng (#${id})`
        }
      });
      window.open(routeData.href, "_blank");
    },
    getStaffName(staffId) {
      const staff = _.find(this.staffs, {
        ID: staffId
      });
      return staff ? staff.FullName : "";
    },
    saveStaff(updateInfo) {
      this.$store.dispatch("main_order/updateOrderDetail", updateInfo);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_order_status_color(value){
      const objStatus = configs.ORDER_STATUS.find(obj => obj.value === value);
      return objStatus ? objStatus.color : 'black';
    },
    exportFile() {
      this.$store.dispatch("main_order/export_order", {filter: this.filterConditions, quickFilter: this.quickFilterConditions});
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "BuyerID", "CustomerServiceID", "ChinaStoreID", "ReceivePlaceID", "ProvinceID"]
      });
    },
    appendProduct() {
      this.newOrder.Products.push(this.newProduct);
      this.newProduct = {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      }
    },
    createData() {
      this.dialogNew = true;
    },
    createNewOrder() {
      if(this.newOrder.Products.length == 0) {
        sendErrorNotice("Hãy nhập danh sách sản phẩm!");
        return;
      }
      if(this.newOrder.UID == 0) {
        sendErrorNotice("Hãy chọn khách hàng!");
        return;
      }
      const cust = _.find(this.customers, {'ID': this.newOrder.UID});
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.newOrder.Username = cust.Username;
      this.newOrder.BuyerID = cust.BuyerID;
      this.newOrder.CustomerServiceID = cust.CustomerServiceID;
      this.newOrder.ChinaStoreID = cust.ChinaStoreID;
      this.newOrder.ReceivePlaceID = cust.ReceivePlaceID;
      this.newOrder.ProvinceID = cust.ProvinceID;

      this.$store.dispatch("main_order/createNew", {'data': this.newOrder, 'param': param});
      this.newOrder = {
        UID: 0,
        Products: []
      };
      this.dialogNew = false;
      sendSuccessNotice('Tạo mới đơn hàng thành công.');
    },
    chooseImage(item) {
        this.newProduct.Image = '';
        this.$refs.fileInput.click();
    },
    previewImage(event) {
        this.imageData = event.target.files[0];
        this.$refs.fileInput.value = null;
        this.onUpload()
    },
    onUpload() {
        const arrFileType = this.imageData.name.split('.');
        const storageRef=firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/${makeid(30)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
        storageRef.on(`state_changed`, snapshot => {
                
            },
            error => {
              sendErrorNotice('File ảnh chỉ được tối đa 1Mb!');
            },
            () => {
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    this.newProduct.Image =url;
                    this.hideImage = true;
                    this.$nextTick(() => this.hideImage = false);
                });
            }
        );
    },
    getImages(index) {
        return this.newOrder.Products[index].Image;
    },
    getStoreName(status, chinaStoreID, receivePlaceID) {
      if(status == 11 || status == 16) {
        const store = _.find(this.chinaStores, { ID: chinaStoreID})
        return store ? store.Name : ''
      }
      if(status == 12 || status == 7 || status == 9) {
        const store = _.find(this.warehouses, { ID: receivePlaceID})
        return store ? store.Name : ''
      }
      return ''
    },
    mergeOrder() {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'MergeOrder', `Bạn có chắc chắn gộp các đơn hàng này không?`);
    }
  },
  created() {
    this.$store.dispatch("commons/getAllUsers");
  },
  mounted() {
    this.filterConditions = [];
    this.quickFilterConditions = [];
    this.$store.dispatch("configuration/getDetail", 1);
    this.$store.dispatch("commons/getProvinces", {});
    this.$store.dispatch("commons/getAllStores");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$store.dispatch("safeLevel/getList");
    this.$store.dispatch("flag/getList");
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_SAVE_DATA", this.exportFile);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
      if(action == 'MergeOrder') {
        let uids = [...new Set(this.selectedOrders.map(o => o.UID)) ];
        if(uids.length > 1) {
          sendErrorNotice('Chức năng chỉ áp dụng với các đơn cùng khách hàng!');
          return;
        }
        this.$store.dispatch("main_order/mergeOrder", {'ids': this.selectedOrders.map(o => o.ID)});
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_SAVE_DATA", this.exportFile);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_ACTION");;
  }
};
</script>
<style lang="stylus" scoped>
.image-product {
  width: 64px;
  height: 64px;
}
</style>